import React, { ReactElement, FunctionComponent } from "react";
import { Card, Spin, Empty } from "antd";
import "./index.scss";
import { ReportRecordTypes } from "../../redux/types/reportTypes";
import PropTypes from "prop-types";

export type GraphProps = {
  records: Array<ReportRecordTypes>;
  yAxisAttr?: string;
};

export type GraphCSVProps = {
  data: Array<ReportRecordTypes>;
  countKey?: string;
};

type AdsOver90DaysGraphProps = {
  title: string;
  loading: boolean;
  records: Array<ReportRecordTypes>;
  Component: FunctionComponent<GraphProps>;
  Extra: FunctionComponent<GraphCSVProps>;
  yAxisAttr?: string;
  countKey?: string;
};

const LoadingGraph = ({
  title,
  loading,
  records,
  Component,
  Extra,
  yAxisAttr,
  countKey,
}: AdsOver90DaysGraphProps): ReactElement => {
  const spin = () => (
    <div className="spin-container">
      <Spin />
    </div>
  );

  const empty = () => (
    <div className="empty-container">
      <Empty />
    </div>
  );

  const render = () => {
    if (loading) return spin();
    if (!records.length) return empty();
    return <Component records={records} yAxisAttr={yAxisAttr} />;
  };

  return (
    <Card
      title={title}
      className="loading-graph"
      extra={<Extra data={records} countKey={countKey} />}
    >
      {render()}
    </Card>
  );
};

LoadingGraph.propTypes = {
  title: PropTypes.string.isRequired,
  records: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  Component: PropTypes.func.isRequired,
  Extra: PropTypes.func.isRequired,
};

export default LoadingGraph;
